import { Typography } from "@mui/material";
import SubscribedLocationCard from "./SubscribedLocationCard";
export default function SubscribedLocationList({
  locations,
  onSelectPackage,
  onConfirm,
  fetchLocations,
  loadMoreLocations,
  totalLocationCount,
  subscriptionDescription,
  onOptOutSuccess,
}) {
  return (
    <div className="user-location-list">
      <div className="locations">
        {locations.map((location) => (
          <SubscribedLocationCard
            location={location}
            key={location.fk_location_id}
            onSelectPackage={onSelectPackage}
            onConfirm={onConfirm}
            fetchLocations={fetchLocations}
            subscriptionDescription={subscriptionDescription}
            onOptOutSuccess={onOptOutSuccess}
          />
        ))}
      </div>
      {totalLocationCount ? (
        <Typography className="fs-10" gutterBottom>
          Locations {locations?.length} of {totalLocationCount}
        </Typography>
      ) : null}
      {loadMoreLocations()}
    </div>
  );
}
